// File Path: frontend/src/component/Documents/DocumentTypeDropdown.jsx
import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  useTheme,
  alpha
} from '@mui/material';
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const DocumentTypeDropdown = ({ value, onChange }) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          color: '#334155',
          fontSize: '0.875rem'
        }}
      >
        Document Type
      </Typography>
      <FormControl fullWidth>
        <Select
          value={value || ''}
          onChange={onChange}
          displayEmpty
          IconComponent={ExpandMoreIcon}
          sx={{
            bgcolor: '#f8fafc',
            borderRadius: 2,
            border: '1px solid #cbd5e1',
            transition: 'all 0.2s',
            '& .MuiSelect-select': {
              py: 1.75,
              px: 2,
              color: '#0f172a',
              fontSize: '0.875rem',
              backgroundColor: '#f8fafc'
            },
            '&:hover': {
              borderColor: '#0044C6',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#0044C6'
              }
            },
            '&.Mui-focused': {
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#0044C6',
                borderWidth: '2px'
              }
            },
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none'
            },
            '& .MuiSelect-icon': {
              color: '#64748b',
              right: 12
            }
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 400,
                borderRadius: 2,
                mt: 1,
                boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.05)',
                '& .MuiMenuItem-root': {
                  fontSize: '0.875rem',
                  py: 1,
                  px: 2
                }
              }
            }
          }}
        >
          <MenuItem disabled value="">
            <em style={{ color: '#090909' }}>Select document type</em>
          </MenuItem>

          {/* Identity & Address Proof */}
          <MenuItem disabled sx={{ opacity: 1, fontWeight: 700, bgcolor: '#f8fafc', color: 'black !important' }}>
            Identity & Address Proof
          </MenuItem>
          <MenuItem value="PANCR" sx={{ pl: 3 }}>PAN Card</MenuItem>
          <MenuItem value="AADHAAR" sx={{ pl: 3 }}>Aadhaar Card</MenuItem>
          <MenuItem value="PASSPORT" sx={{ pl: 3 }}>Passport</MenuItem>
          <MenuItem value="DRIVING_LICENSE" sx={{ pl: 3 }}>Driving License</MenuItem>
          <MenuItem value="VOTER_ID" sx={{ pl: 3 }}>VOTER ID</MenuItem>

          {/* Educational Documents */}
          <MenuItem disabled sx={{ opacity: 1, fontWeight: 700, bgcolor: '#f8fafc', color: 'black !important', mt: 1 }}>
            Educational Documents
          </MenuItem>
          <MenuItem value="MARKSHEET_10TH" sx={{ pl: 3 }}>10th Marksheet / Certificate</MenuItem>
          <MenuItem value="MARKSHEET_12TH" sx={{ pl: 3 }}>12th Marksheet</MenuItem>
          <MenuItem value="DEGREE_UG" sx={{ pl: 3 }}>Graduation Degree</MenuItem>
          <MenuItem value="DEGREE_PG" sx={{ pl: 3 }}>Post Graduation Degree</MenuItem>
          <MenuItem value="PROF_CERT" sx={{ pl: 3 }}>Professional Certificate</MenuItem>

          {/* Previous Employment */}
          <MenuItem disabled sx={{ opacity: 1, fontWeight: 700, bgcolor: '#f8fafc', color: 'black !important', mt: 1 }}>
            Previous Employment
          </MenuItem>
          <MenuItem value="EXP_LETTER" sx={{ pl: 3 }}>Experience Letter</MenuItem>
          <MenuItem value="RELIEVING_LETTER" sx={{ pl: 3 }}>Relieving Letter</MenuItem>
          <MenuItem value="PREV_OFFER" sx={{ pl: 3 }}>Previous Offer Letter</MenuItem>
          <MenuItem value="SALARY_SLIPS" sx={{ pl: 3 }}>Last 3 Months Salary Slips</MenuItem>
          <MenuItem value="FORM_16" sx={{ pl: 3 }}>Form 16</MenuItem>
          <MenuItem value="BANK_STATEMENT" sx={{ pl: 3 }}>Bank Statement</MenuItem>

          {/* Bank Details & Tax */}
          <MenuItem disabled sx={{ opacity: 1, fontWeight: 700, bgcolor: '#f8fafc', color: 'black !important', mt: 1 }}>
            Bank Details & Tax
          </MenuItem>
          <MenuItem value="CANCELLED_CHEQUE" sx={{ pl: 3 }}>Cancelled Cheque</MenuItem>
          <MenuItem value="PASSBOOK" sx={{ pl: 3 }}>Bank Passbook Copy</MenuItem>
          <MenuItem value="FORM_12B" sx={{ pl: 3 }}>Form 12B</MenuItem>
          <MenuItem value="INVESTMENT_PROOF" sx={{ pl: 3 }}>Investment Proofs</MenuItem>
          <MenuItem value="UAN_EPF" sx={{ pl: 3 }}>UAN Number (EPF)</MenuItem>
          <MenuItem value="ESIC_CARD" sx={{ pl: 3 }}>ESIC Card</MenuItem>

          {/* Company Forms & Others */}
          <MenuItem disabled sx={{ opacity: 1, fontWeight: 700, bgcolor: '#f8fafc', color: 'black !important', mt: 1 }}>
            Company Forms & Others
          </MenuItem>
          <MenuItem value="PHOTOGRAPH" sx={{ pl: 3 }}>Passport Size Photograph</MenuItem>
          <MenuItem value="OFFER_ACCEPT" sx={{ pl: 3 }}>Offer Letter Acceptance</MenuItem>
          <MenuItem value="EMP_AGREEMENT" sx={{ pl: 3 }}>Employment Agreement</MenuItem>
          <MenuItem value="NDA" sx={{ pl: 3 }}>Non-Disclosure Agreement (NDA)</MenuItem>
          <MenuItem value="COC" sx={{ pl: 3 }}>Code of Conduct Form</MenuItem>
          <MenuItem value="BGC_CONSENT" sx={{ pl: 3 }}>Background Verification Consent</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default DocumentTypeDropdown;